import {createAction} from "redux-act";
import {IAutoSwap} from "modules/actions/team";

export interface IInvitesModal {
	success: boolean;
	error?: string;
}
export const showInvitesModal = createAction<IInvitesModal>();
export const hideInvitesModal = createAction();

export const showLeagueRolloverModal = createAction();
export const hideLeagueRolloverModal = createAction();

export const hideWelcomeModal = createAction();

export const showAuthenticationModal = createAction();
export const hideAuthenticationModal = createAction();

export const showNextSeasonModal = createAction();
export const hideNextSeasonModal = createAction();

export const showTournamentModal = createAction<number>();
export const hideTournamentModal = createAction();

export const showBoostersModal = createAction();
export const hideBoostersModal = createAction();

export const showAutoSwapModal = createAction<IAutoSwap>();
export const hideAutoSwapModal = createAction();
